import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";
import { cn } from "@/lib/utils";
import BboxSvg from "pages/geoscape-data/clip/clip-ui/icons/bbox.svg?react";
import CircleSvg from "pages/geoscape-data/clip/clip-ui/icons/circle.svg?react";
import PolygonSvg from "pages/geoscape-data/clip/clip-ui/icons/polygon.svg?react";

interface DrawToolbarProps {
  draw: MapboxDraw;
  currentMode: string;
  onModeChange: (mode: string) => void;
}

const drawTools = [
  { mode: "draw_rectangle", label: "Rectangle", Icon: BboxSvg },
  { mode: "draw_polygon", label: "Polygon", Icon: PolygonSvg },
  { mode: "draw_circle", label: "Circle", Icon: CircleSvg },
] as const;

export function DrawToolbar({ draw, currentMode, onModeChange }: DrawToolbarProps) {
  return (
    <div className="flex flex-row gap-2">
      {drawTools.map((tool) => {
        const isActive = currentMode === tool.mode;
        return (
          <Tooltip key={tool.mode}>
            <TooltipTrigger asChild>
              <button
                type="button"
                onClick={() => {
                  draw.changeMode(tool.mode as any);
                  onModeChange(tool.mode);
                }}
                aria-label={tool.label}
                aria-pressed={isActive}
                className={cn(
                  "ring-foreground/10 bg-card text-card-foreground hover:bg-accent flex size-10 items-center justify-center rounded-lg ring-1 cursor-pointer transition-colors",
                  isActive && "bg-accent",
                )}
              >
                <tool.Icon className="fill-foreground" />
              </button>
            </TooltipTrigger>
            <TooltipContent>{tool.label}</TooltipContent>
          </Tooltip>
        );
      })}
    </div>
  );
}
